import { useQuery, UseQueryResult, QueryFunctionContext } from 'react-query';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import unionWith from 'lodash/unionWith';
import { httpClient } from 'src/utils/HttpClients';
import type { TUser } from 'src/types';
import { useAppState } from 'src/context';

type ParamsType = {
    [key: string]: number | string | null;
};

export const useFindUsers = (query: string, onlyMyTeam?: boolean): UseQueryResult<TUser[]> => {
    const {
        values: { users },
        actions: { handleSetUsers },
    } = useAppState();

    const queryFn = async (context: QueryFunctionContext<string[]> | undefined) => {
        const signal = context?.signal;
        const params: ParamsType = {
            page: 1,
            itemsPerPage: 200,
            search: query,
            format: 'manager',
            action: onlyMyTeam ? 'team' : null,
        };

        const response = await httpClient.get(`/users/list`, {
            params: omitBy(params, isNil),
            signal,
        });

        return get(response, 'data.data', [] as TUser[]);
    };

    const onSettled = async (data: TUser[] | undefined) => {
        const grouped = unionWith(users, data, isEqual);
        handleSetUsers(grouped);
    };

    return useQuery(['users', query], queryFn, {
        keepPreviousData: false,
        enabled: !!query.length,
        onSettled,
    });
};
